module.exports = __webpack_public_path__ + "img/user_default.0061187f.png";